import { useContext, useEffect, useMemo, useState } from "react";
import { SharingTag } from "components/ui/atoms/Tag";
import Grid from "@mui/material/Grid";
import { useExcludeSharing, useAllSharing } from "./apiSharing";
import { SnackbarContext } from "components/context/SnackbarProvider";

const DealSharings = ({ deal }) => {
  const [sharingLinks, setSharingLinks] = useState([
    ...deal.deal_sharing_links,
  ]);
  const { data: sharings } = useAllSharing();
  const { mutateAsync: mutateExclude } = useExcludeSharing();
  const { displayError } = useContext(SnackbarContext);

  if (deal.deal_sharing_links == undefined)
    return "Error, can't display DealSharings.";

  const dicoSharings = useMemo(() => {
    if (!sharings) return null;
    return Object.fromEntries(sharings.map((s) => [s.id, s]));
  }, [sharings]);

  const excludeSharing = (link) => {
    mutateExclude({ id: link.sharing_id, deal_id: deal.id })
      .then(() => {
        setSharingLinks(sharingLinks.filter((l) => l != link));
      })
      .catch(displayError);
  };

  useEffect(() => {
    setSharingLinks([...deal.deal_sharing_links]);
  }, [deal]);

  if (!sharings) return "Loading";

  return (
    <Grid container spacing={1}>
      {sharingLinks.map(
        (link) =>
          link.real_status == "included" && (
            <Grid key={link.id}>
              {dicoSharings[link.sharing_id] && (
                <SharingTag
                  sharing={dicoSharings[link.sharing_id]}
                  onDelete={() => excludeSharing(link)}
                />
              )}
            </Grid>
          ),
      )}
    </Grid>
  );
};

export default DealSharings;
